import { MedplumClient } from "@medplum/core";
import type { Observation, QuestionnaireResponse } from "@medplum/fhirtypes";

import { inferLaborStageMembershipChangesForVersionDiff } from "@/encounters/components/EncounterLabor/utils/infer-labor-stage-membership-changes-for-version-diff";
import type { LaborAmendStageMembershipChangeRecord } from "@/encounters/types/labor-amend-provenance";

export interface ResolveLaborStageMembershipChangesForVersionDiffParams {
  medplum: MedplumClient;
  laborStageObservationsForDiff: Observation[];
  previousEncounterQuestionnaireResponse?: QuestionnaireResponse;
  currentEncounterQuestionnaireResponse?: QuestionnaireResponse;
  provenanceStageMembershipChanges: LaborAmendStageMembershipChangeRecord[];
  provenanceTargetObservationIds?: ReadonlySet<string>;
}

/**
 * Resolves labor stage membership changes for version diff from provenance, with history inference fallback.
 */
export async function resolveLaborStageMembershipChangesForVersionDiff({
  medplum,
  laborStageObservationsForDiff,
  previousEncounterQuestionnaireResponse,
  currentEncounterQuestionnaireResponse,
  provenanceStageMembershipChanges,
  provenanceTargetObservationIds,
}: ResolveLaborStageMembershipChangesForVersionDiffParams): Promise<
  LaborAmendStageMembershipChangeRecord[]
> {
  if (provenanceStageMembershipChanges.length > 0) {
    return provenanceStageMembershipChanges;
  }

  if (!previousEncounterQuestionnaireResponse) {
    return [];
  }

  return inferLaborStageMembershipChangesForVersionDiff(
    medplum,
    laborStageObservationsForDiff,
    previousEncounterQuestionnaireResponse,
    currentEncounterQuestionnaireResponse,
    provenanceTargetObservationIds,
  );
}
